import { render, staticRenderFns } from "./HazmatCodeView.vue?vue&type=template&id=447d7bf6&scoped=true&"
import script from "./HazmatCodeView.vue?vue&type=script&lang=js&"
export * from "./HazmatCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d7bf6",
  null
  
)

export default component.exports